import { create } from 'zustand';

const useRestaurantNotificationStore = create((set) => ({
  newOrderCounts: {},
  incrementNewOrderCount: (restaurantId) =>
    set((state) => ({
      newOrderCounts: {
        ...state.newOrderCounts,
        [restaurantId]: (state.newOrderCounts[restaurantId] || 0) + 1,
      },
    })),
  clearNewOrderCount: (restaurantId) =>
    set((state) => {
      if (!restaurantId) return state;
      if (!state.newOrderCounts[restaurantId]) return state; // ✅ Preserve store when no change needed
      return {
        newOrderCounts: {
          ...state.newOrderCounts,
          [restaurantId]: 0,
        },
      };
    }),
}));

export default useRestaurantNotificationStore;
